import React, { useState } from "react";
import { Compliments } from "./compliments";
import { CommentButton } from "./comments";
import { SharePost } from "./sharePost";
import { QuotePost } from "./quotePost";
import { getUserData } from "../../Helpers/utils";
import { USER_TYPES } from "../../Helpers/constants";

// Define the types for the props
interface PostMetaProps {
  postID: number; // or number, depending on your data type
  comments: number;
  likes: number;
  postIsLiked: boolean;
  isCommentOpen: boolean;
  setIsCommentOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const PostMeta: React.FC<PostMetaProps> = ({
  postID,
  likes,
  comments,
  postIsLiked,
  isCommentOpen,
  setIsCommentOpen,
}) => {
  const [isLiked, setIsLiked] = useState(postIsLiked);
  const user = getUserData();
  return (
    <div className="flex items-center gap-3">
      <Compliments
        isLiked={isLiked}
        postId={postID}
        initialLikes={likes}
        setIsLiked={setIsLiked}
      />
      <CommentButton
        postId={postID}
        comments={comments}
        isCommentsOpen={isCommentOpen}
        setIsCommentsOpen={setIsCommentOpen}
      />
      <SharePost postId={postID} />
      {user?.user.user_type === USER_TYPES.professional && (
        <QuotePost postId={postID} />
      )}
    </div>
  );
};
